import { render, staticRenderFns } from "./AnnualComparisonCompare.vue?vue&type=template&id=5bb6391d&scoped=true"
import script from "./AnnualComparisonCompare.vue?vue&type=script&lang=js"
export * from "./AnnualComparisonCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb6391d",
  null
  
)

export default component.exports